import { Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/SupabaseAuthContext';
import BannedScreen from '@/components/BannedScreen';
import MaintenanceScreen from '@/components/MaintenanceScreen';

const DefaultFallback = () => (
  <div className="fixed inset-0 flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
  </div>
);

export default function ProtectedRoute({ fallback = <DefaultFallback />, unauthenticatedElement }) {
  const { isAuthenticated, isLoadingAuth, authChecked, isBanned, isAdmin, maintenanceMode } = useAuth();

  if (isLoadingAuth || !authChecked) {
    return fallback;
  }

  if (!isAuthenticated) {
    return unauthenticatedElement;
  }

  if (isBanned) {
    return <BannedScreen />;
  }

  if (maintenanceMode && !isAdmin) {
    return <MaintenanceScreen />;
  }

  return <Outlet />;
}